import { useCallback } from 'react';

import { SelectChangeEvent } from '@mui/material';

import { DropdownRadioOption } from './DropdownRadioOption';

interface IUseMultiSelectOnChange {
  currentMode: 'radio' | 'checkbox'
  onChange: (value: string[]) => void;
}

export const useMultiSelectOnChange = (props: IUseMultiSelectOnChange) => {
  const { onChange, currentMode } = props;

  const handleChange = useCallback((event: SelectChangeEvent<string[]>, child: React.ReactElement) => {
    const {
      target: { value },
    } = event;
    const mode = child.type === DropdownRadioOption ? 'radio' : 'checkbox';
    const selected = typeof value === 'string' ? value.split(',') : value || [];
    onChange(mode === 'radio' || currentMode === 'radio' ? [child.props.value] : selected);
  }, [currentMode, onChange]);

  return handleChange;
};
